// eslint-disable-next-line import/prefer-default-export
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';

